import React from 'react';
import { TimeSlot } from './steps/SelectYourAvailability';

interface TimeSlotItemProps {
  time: TimeSlot;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

const TimeSlotItem: React.FC<TimeSlotItemProps> = ({
  time,
  isSelected,
  isDisabled,
  onClick,
}) => (
  <div
    className={`flex flex-col bg-[#32395E] gap-2 px-4 py-3 rounded-full transition-all duration-300 
        ${isSelected ? 'bg-[#ABE49C] text-black' : ''}
        ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    onClick={() => {
      if (!isDisabled) {
        onClick();
      }
    }}
  >
    <div className="text-[0.875rem] font-semibold flex items-center">
      {time.label}
    </div>
  </div>
);

export default TimeSlotItem;
